import { string, object, func, bool, array } from 'prop-types'
import { Fragment } from 'react'
import { ContentTextInput } from '../../../../ContentTextInput'
import { LinkPreviewAssetCarousel } from '../../../../LinkPreviewAssetCarousel'
import useContentWithLinkPreviewAssetCarousel from '../../../helpers/hooks/useContentWithLinkPreviewAssetCarousel'
import { FacebookHeader } from '../../SharedDisplays'
import { styles } from './styles'

export const FacebookStandardHeader = ({
  accountImage,
  accountName,
  assets = [],
  collabEnabled,
  collabAccount,
  content,
  display,
  isPresenting,
  linksWithData = [],
  onContentChange,
  onLinkDataUpdate,
  onShowAssetPicker,
  readOnly,
  scheduledAt,
  timezone,
  truncate,
}) => {
  const {
    link,
    isPersistingLink,
    setIsPersistingLink,
    linkWithData,
    isFirstLinkAssetSquare,
  } = useContentWithLinkPreviewAssetCarousel({
    content,
    linksWithData,
  })
  const linkAssets = linkWithData ? linkWithData.assetReferences : []

  const truncationLimits = {
    mobileSingle: 315,
    desktopNewsFeed: 480,
    desktopTimeline: 477,
  }

  return (
    <Fragment>
      <FacebookHeader
        accountName={accountName}
        accountImage={accountImage}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        scheduledAt={scheduledAt}
        timezone={timezone}
      />
      <div style={styles.contentWrapper}>
        <ContentTextInput
          placeholder="Add content..."
          readOnly={readOnly}
          value={content}
          highlightSocialTags={true}
          truncationLimit={truncationLimits[display] || 477}
          characterLimit={63206}
          truncate={truncate}
          onChange={(val) => onContentChange(val)}
        />
      </div>
      {assets.length === 0 && isPersistingLink && (
        <div style={styles.previewWrapper}>
          <LinkPreviewAssetCarousel
            linkWithData={linkWithData}
            hasSquareInlineAsset={display !== 'mobileSingle'}
            link={link}
            readOnly={readOnly || isPresenting}
            onShowAssetPicker={onShowAssetPicker}
            onLinkDataUpdate={onLinkDataUpdate}
            hasRemovedLink={() => setIsPersistingLink(false)}
            assetStyle={styles.linkAssetStyle(
              display,
              linkAssets.length,
              isFirstLinkAssetSquare
            )}
            descriptionStyle={styles.linkDescriptionStyle(display)}
            domainStyle={styles.linkDomainStyle(
              display,
              isFirstLinkAssetSquare
            )}
            linkStyle={styles.linkStyle(
              display,
              linkAssets.length,
              isFirstLinkAssetSquare,
              readOnly || isPresenting
            )}
            titleStyle={styles.linkTitleStyle(display)}
          />
        </div>
      )}
    </Fragment>
  )
}

FacebookStandardHeader.propTypes = {
  accountImage: object,
  accountName: string,
  assets: array,
  collabEnabled: bool,
  collabAccount: string,
  content: string,
  display: string,
  isPresenting: bool,
  linksWithData: array,
  onContentChange: func,
  onLinkDataUpdate: func,
  onShowAssetPicker: func,
  readOnly: bool,
  scheduledAt: string,
  timezone: string,
  truncate: bool,
}
